import { defineMessages } from 'react-intl'

export default defineMessages({
  cardTitle: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.Title',
    defaultMessage: 'SAML Identity Provider'
  },
  createButton: {
    id: 'Create',
    defaultMessage: 'Create'
  },
  description: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.Description',
    defaultMessage:
      "Workgrid supports SAML 2.0 identity providers. By adding an identity provider users of the Admin Console can sign in with your company's enterprise credentials."
  },
  emailAttribute: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.EmailAttribute',
    defaultMessage: 'Email Attribute'
  },
  emailAttributePlaceholder: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.EmailAttributePlaceholder',
    defaultMessage: 'Email'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  familyNameAttribute: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.FamilyNameAttribute',
    defaultMessage: 'Family Name Attribute'
  },
  familyNameAttributePlaceholder: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.FamilyNameAttributePlaceholder',
    defaultMessage: 'LastName'
  },
  identityProvider: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.IdentityProvider',
    defaultMessage: 'Identity Provider'
  },
  identityProviderAzureActiveDirectory: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.IdentityProviderAzureActiveDirectory',
    defaultMessage: 'Azure Active Directory'
  },
  identityProviderOkta: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.IdentityProviderOkta',
    defaultMessage: 'Okta'
  },
  identityProviderOther: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.IdentityProviderOther',
    defaultMessage: 'Other'
  },
  metadata: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.SamlMetadata',
    defaultMessage: 'SAML Metadata'
  },
  metadataDescription: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.SamlMetadataDescription',
    defaultMessage: 'This field should contain the XML metadata of your identity provider.'
  },
  metadataInvalidXml: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.SamlMetadataInvalidXml',
    defaultMessage: 'Invalid XML format.'
  },
  metadataPlaceholder: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.SamlMetadataPlaceholder',
    defaultMessage:
      '<md:EntityDescriptor entityID="https://sso.example.org/idp" validUntil="2017-08-30T19:10:29Z"\n                     xmlns:md="urn:oasis:names:tc:SAML:2.0:metadata"\n                     xmlns:saml="urn:oasis:names:tc:SAML:2.0:assertion"\n                     xmlns:mdrpi="urn:oasis:names:tc:SAML:metadata:rpi"\n                     xmlns:mdattr="urn:oasis:names:tc:SAML:metadata:attribute"\n                     xmlns:mdui="urn:oasis:names:tc:SAML:metadata:ui"\n                     xmlns:ds="http://www.w3.org/2000/09/xmldsig#">\n  <!-- insert ds:Signature element (omitted) -->\n  <md:Extensions>\n    <mdrpi:RegistrationInfo registrationAuthority="https://registrar.example.net"/>\n    <mdrpi:PublicationInfo creationInstant="2017-08-16T19:10:29Z" publisher="https://registrar.example.net"/>\n    <mdattr:EntityAttributes>\n      <saml:Attribute Name="http://registrar.example.net/entity-category" NameFormat="urn:oasis:names:tc:SAML:2.0:attrname-format:uri">\n        <saml:AttributeValue>https://registrar.example.net/category/self-certified</saml:AttributeValue>\n      </saml:Attribute>\n    </mdattr:EntityAttributes>\n  </md:Extensions>\n  <md:IDPSSODescriptor protocolSupportEnumeration="urn:oasis:names:tc:SAML:2.0:protocol">\n    <md:Extensions>\n      <mdui:UIInfo>\n        <mdui:DisplayName xml:lang="en">Example.org</mdui:DisplayName>\n        <mdui:Description xml:lang="en">The identity provider at Example.org</mdui:Description>\n        <mdui:Logo height="32" width="32" xml:lang="en">https://idp.example.org/myicon.png</mdui:Logo>\n      </mdui:UIInfo>\n    </md:Extensions>\n    <md:KeyDescriptor use="signing">\n      <ds:KeyInfo>...</ds:KeyInfo>\n    </md:KeyDescriptor>\n    <md:SingleSignOnService Binding="urn:oasis:names:tc:SAML:2.0:bindings:HTTP-Redirect" Location="https://idp.example.org/SAML2/SSO/Redirect"/>\n    <md:SingleSignOnService Binding="urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST" Location="https://idp.example.org/SAML2/SSO/POST"/>\n  </md:IDPSSODescriptor>\n  <md:Organization>\n    <md:OrganizationName xml:lang="en">Example.org Non-Profit Org</md:OrganizationName>\n    <md:OrganizationDisplayName xml:lang="en">Example.org</md:OrganizationDisplayName>\n    <md:OrganizationURL xml:lang="en">https://www.example.org/</md:OrganizationURL>\n  </md:Organization>\n  <md:ContactPerson contactType="technical">\n    <md:SurName>SAML Technical Support</md:SurName>\n    <md:EmailAddress>mailto:technical-support@example.org</md:EmailAddress>\n  </md:ContactPerson>\n</md:EntityDescriptor>'
  },
  requiredError: {
    id: 'FormError.Required',
    defaultMessage: 'Please enter a value.'
  },
  usernameAttribute: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.UsernameAttribute',
    defaultMessage: 'Name Attribute'
  },
  usernameAttributePlaceholder: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.UsernameAttributePlaceholder',
    defaultMessage: 'FirstName'
  }
})
